import { useState } from 'react';
import { Bell } from 'lucide-react';
import { useUIStore } from '../../stores/uiStore';
import { NotificationSlideOver } from './NotificationSlideOver';
import styles from './NotificationBell.module.css';

// WS-4a (C1) — header bell. Reads `uiStore.notifications.unreadCount`
// (kept fresh by the 60s `useUnreadCountPoll` query at the app shell
// level), opens the real slide-over with one click. No fake actions:
// every visible affordance maps to a real backend mutation.

export function NotificationBell(): JSX.Element {
  const unreadCount = useUIStore((s) => s.notifications.unreadCount);
  const [open, setOpen] = useState(false);
  const hasUnread = unreadCount > 0;
  const badgeText = unreadCount > 99 ? '99+' : String(unreadCount);
  return (
    <>
      <button
        type="button"
        className={styles.trigger}
        aria-label={
          hasUnread
            ? `Notifications — ${unreadCount} unread`
            : 'Notifications — none unread'
        }
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        data-testid="notification-bell"
      >
        <Bell size={18} strokeWidth={1.5} aria-hidden="true" />
        {hasUnread ? (
          <span
            className={styles.badge}
            aria-hidden="true"
            data-testid="notification-unread-badge"
          >
            {badgeText}
          </span>
        ) : null}
      </button>
      <NotificationSlideOver open={open} onClose={() => setOpen(false)} />
    </>
  );
}
